export default "__VITE_ASSET__CKJ0fhW5__"